import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "../store/states/app";
import { BehaviorSubject, Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuctionsTrackingService {
  private trackInfo = new BehaviorSubject(null);
  private auctionStartedData = new Subject();
  private auctionEndedData = new Subject();

  constructor() {}

  setTrackInfo(data) {
    this.trackInfo.next(data);
  }

  setAuctionStartedData(data) {
    this.auctionStartedData.next(data);
  }

  setAuctionEndedData(data) {
    this.auctionEndedData.next(data);
  }

  get track() {
    return this.trackInfo as Observable<any>;
  }

  get auctionStarted() {
    return this.auctionStartedData as Observable<any>;
  }

  get auctionEnded() {
    return this.auctionEndedData as Observable<any>;
  }
}
